var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.tx ? _c('div', {
    staticClass: "card meta"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('p', {
    staticClass: "evm_tx_type_label"
  }, [_vm._t("default")], 2), _c('h2', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('p', {
          staticClass: "click_to_copy"
        }, [_c('span', _vm._g({
          staticClass: "tx_hash",
          on: {
            "click": _vm.copy
          }
        }, on), [_vm._v(" Transaction Detail ")])])];
      }
    }], null, false, 3619172923)
  }, [_c('span', [_vm._v("Click to copy")])])], 1)]), _c('div', {
    attrs: {
      "id": "evm_tx_tabs"
    }
  }, [_c('v-tabs', {
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    attrs: {
      "href": "#overview"
    }
  }, [_vm._v("Overview")]), _vm.hasTraces ? _c('v-tab', {
    attrs: {
      "href": "#traces"
    }
  }, [_vm._v("Traces (" + _vm._s(_vm.tx.traces.length) + ")")]) : _vm._e(), _vm.hasTransfers ? _c('v-tab', {
    attrs: {
      "href": "#transfers"
    }
  }, [_vm._v("Transfers (TBD)")]) : _vm._e(), _vm.hasLogs ? _c('v-tab', {
    attrs: {
      "href": "#logs"
    }
  }, [_vm._v("Events (" + _vm._s(_vm.tx.logs.length) + ")")]) : _vm._e(), _c('v-tab-item', {
    staticClass: "tab_content",
    attrs: {
      "value": "overview"
    }
  }, [_c('EVMMetadata', {
    attrs: {
      "tx": _vm.tx
    }
  })], 1), _vm.hasTraces ? _c('v-tab-item', {
    staticClass: "tab_content",
    attrs: {
      "value": "traces"
    }
  }, [_c('EVMExecutionTrace', {
    attrs: {
      "traces": _vm.tx.tracesGraph
    }
  })], 1) : _vm._e(), _vm.hasTransfers ? _c('v-tab-item', {
    staticClass: "tab_content",
    attrs: {
      "value": "transfers"
    }
  }) : _vm._e(), _vm.hasLogs ? _c('v-tab-item', {
    staticClass: "tab_content",
    attrs: {
      "value": "logs"
    }
  }, _vm._l(_vm.tx.logs, function (log) {
    return _c('EVMLogRow', {
      key: log.logIndex,
      attrs: {
        "log": log
      }
    });
  }), 1) : _vm._e()], 1)], 1)]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }